import { Injectable } from '@angular/core';
import { AppService } from "../../core/services/app.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  constructor(public http: HttpClient) {
  }
  
  getConfig(type?) {
    let filter: any = {
      where: {
        type: 'popup'
      }
    };
  
    filter = encodeURIComponent(JSON.stringify(filter));
    
    return this.http.get(AppService.getApiUrl() + `/api/pageConfigs?filter=${filter}`);
  }
  
  saveConfig(data) {
    return this.http.post(AppService.getApiUrl() + '/api/pageConfigs/', data);
  }
  
  updateConfig(id, data) {
    return this.http.put(AppService.getApiUrl() + '/api/pageConfigs/' + id, data);
  }
}
